var locale = {
  placeholder: 'Select time'
};
export default locale;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.12.2@antd/es/time-picker/locale/en_US.js
// module id = 155
// module chunks = 0